class Room {
	// CASL subject type detection
	static get modelName() {
		return "Room";
	}

	constructor({ _id, _operatorId, _communityId, _name, _users }) {
		this.id = _id;
		this.operator  = _operatorId;
		this.community  = _communityId;
		this.name = _name;
		this.users = _users;

	}
}

export function createRoom(item) {
	return Object.freeze(new Room(item));
}
